export default __webpack_public_path__ + "static/media/mobPOS.def515ca.png";